'use client';

import { Button } from '@ui/components/button';
import { AppCard } from '@ui/components/layouts';
import { Separator } from '@ui/components/separator';
import { text as sharedText } from '@shared/text';
import { text as change_passwordText } from '@modules/change-password/text';
import { text as settingsText } from '@modules/settings/text';

import type { SettingsProps } from '@modules/settings/containers/settings_container';
import { PageContentLoading } from '@/src/components/PageContentLoading';

export function Settings({
  isLoading,
  saveMessage,
  isSaving,
  onChangePassword,
  onSignOut,
}: SettingsProps) {
  if (isLoading) {
    return <PageContentLoading />;
  }

  return (
    <div className="flex w-full flex-col gap-4">
      <h2 className="text-foreground text-xl font-semibold">{settingsText.appSectionTitle}</h2>
      <AppCard className="w-full p-5">
        <div className="flex flex-col gap-5">
          {saveMessage ? <p className="text-muted-foreground text-sm">{saveMessage}</p> : null}
          {isSaving ? <p className="text-muted-foreground text-sm">{sharedText.saving}</p> : null}

          {onChangePassword ? (
            <Button
              type="button"
              variant="outline"
              className="w-full"
              size="lg"
              disabled={isSaving}
              onClick={onChangePassword}>
              {change_passwordText.action}
            </Button>
          ) : null}

          {onSignOut ? (
            <>
              <Separator />
              <Button
                type="button"
                variant="outline"
                className="w-full"
                size="lg"
                disabled={isSaving}
                onClick={() => void onSignOut()}>
                {settingsText.signOut}
              </Button>
            </>
          ) : null}
        </div>
      </AppCard>
    </div>
  );
}
